export default "/_next/static/chunks/fonts/aquatico-regular-8a72921cd1a60189fd990673a368fb98.woff2";